import React from 'react';

// MuiComponents
import { Paper, Tabs, Tab } from '@material-ui/core';

// HoC
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import history from '../../../common/constants/config/history';

// Components;
import LayoutContent from 'common/oldJavascripts/components/Base/Layout/LayoutContent';
import Box from 'common/oldJavascripts/components/Base/Box';
import tabs from './tabs';

const styles = {
  topMargin: {
    marginTop: 16,
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: '#0000ff',
  },
  container: {
    padding: 16,
  },
};

const ToolsTab = ({ classes, tab = null }) => {
  const tabIndex = tab || 0;

  const handleTabChange = (_event, value) => {
    const href = `/tools/${tabs[value].id}`;
    history.push(href);
  };

  const activeTab = tabs[tabIndex] || {};
  const content = activeTab.component;

  return (
    <LayoutContent>
      <Box>
        <Paper elevation={0}>
          <Tabs
            indicatorColor="secondary"
            textColor="secondary"
            onChange={handleTabChange}
            value={tabIndex}
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            {tabs.map(({ id, label, test_id }) => (
              <Tab
                key={`tools-tab-${id}`}
                label={label}
                data-test-id={`ToolsTab-${test_id}`}
              />
            ))}
          </Tabs>
        </Paper>

        <Paper elevation={0} className={classes.container}>
          <Box data-test-id={`ToolsTab-content-${activeTab.id}`}>{content}</Box>
        </Paper>
      </Box>
    </LayoutContent>
  );
};

export default compose(withRouter, withStyles(styles))(ToolsTab);
